import { useGLTF, Edges, PresentationControls, Center } from "@react-three/drei";
import React from "react";
import * as THREE from 'three'


const material = new THREE.MeshStandardMaterial({
    color: '#ffffef',
    side: THREE.DoubleSide
})


export const Senevisium = React.forwardRef((props, ref) => {

    const { nodes, materials } = useGLTF(import.meta.env.BASE_URL + 'static/models/senevisium.glb')

    console.log(nodes)
    return <>
        <mesh {...props} ref={ref} dispose={null} geometry={nodes.Senescent_fibroblast_.geometry} material={material}>
            <Edges
                geometry={nodes.Senescent_fibroblast_.geometry}
                lineWidth={0.7}
                threshold={0.5}
                color="black"
                scale={1}
                opacity={.8} 
                depthTest={true}
                depthWrite={false}
                renderOrder={1000}
                polygonOffset={false}
                polygonOffsetFactor={10}
            />
        </mesh>

    </>




})

useGLTF.preload(import.meta.env.BASE_URL + 'static/models/senevisium.glb')